import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { AccountService } from '../../../services/account.service';
import { WatchAccountService } from '../../../services/watch-account.service';
import { DriveType, IInbox } from '../../../interfaces/graph-types';

type ImportSource = 'gmail' | 'csv';

@Component({
  template: require('./modal-import-candidates.component.pug'),
  styles: [require('./modal-import-candidates.component.css').toString()],
})
export class ModalImportCandidatesComponent {
  importSource: ImportSource;
  drives$: Subscription;
  areDrivesLoading = true;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private watchAccount: WatchAccountService,
    private accountService: AccountService,
  ) {}

  ngOnInit() {
    this.drives$ = this.accountService
      .drives(this.watchAccount.accountId().getValue(), DriveType.GDrive)
      .subscribe(drives => {
        if (drives) {
          if (drives.length === 0) {
            this.importSource = 'csv';
          }
          this.areDrivesLoading = false;
        }
      });
  }

  setImportSource(source: ImportSource) {
    this.importSource = source;
  }
}
